import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { colors, fluidTypeScale, spacing } = useTheme();

  return {
    link: css`
      font-size: ${fluidTypeScale.font20_20} !important;
      color: ${colors.white};
      font-weight: 400;
      text-align: center;
      padding-top: ${spacing.xs};

      button {
        display: inline-block;
        padding: 0 3px;
      }
      &:focus-visible {
        color: ${colors.border_black};
        background-color: ${colors.skip_yellow};
        outline: none;
        border: none;
        text-decoration: underline;
        text-decoration-color: ${colors.border_black};
      }
    `,
    ageTitle: css`
      &:hover {
        font-weight: 700;
      }
    `,
    externalLink: css`
      color: ${colors.white};
      font-weight: 400;
      font-size: ${fluidTypeScale.font20_20} !important;
      display: inline;
      border: 1px solid transparent;
      max-width: 100%;
      width: 100%;
      margin: 0 auto;
      text-align: center;

      &:hover {
        font-weight: 700;
      }

      &:focus {
        outline: 0;
        border: 1px solid ${colors.white};
      }
      &:focus-visible {
        padding-top: 0;
      }
    `,
    OnboardingWrapper: css`
      margin: 1.5rem 0;
    `,
    daysLink: css`
      text-transform: lowercase;

      &:hover {
        font-weight: 700;
      }
    `,
  };
};
